module.exports = __webpack_public_path__ + "static/media/loading-screen.4b48d652.jpg";